<template>
    <div>
        <h1>Contatos</h1>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="list-group">
                        <div  class="list-group-item" :key="index" v-for="(item,index) in content"> 
                            <div class="d-flex w-100 justify-content-between">
                                <h4 class="mb-1">{{item.nome}}</h4>
                                <small>{{item.tsData}}</small>
                            </div>
                            <p class="mb-1 small">{{item.email}} / {{item.telefone}}</p>
                            <p class="mb-1">Assunto: <br><b>{{item.assunto}}</b></p>
                            <p class="mb-1">Mensagem: <br><b>{{item.mensagem}}</b></p>
                        </div>
                         <div  class="list-group-item text-center" v-if="content.length == 0"> 
                            <p class="mb-1 small">Nenhum registro encontrado</p>
                        </div>
                       
                    </div>                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getData } from "../global/utils";

    export default {
        data: function () {
            return {
            stripe: true,
            colorAlert: "primary",
            titleAlert: "",
            segmentoId: "",
            activeAlert: false,
            content: [],
            iconArea: 50 * 1,
            errors: [],
            erro: "",
            urlApi: "gape",
            carregando: true,
            deleteId: "",
            deleteAtivo: null,
            deleteTitulo: "",
            };
        },

        mounted() {
            this.fnCarregaItems();
        },
        methods: {
            async fnCarregaItems() {
            let data = await getData(
                this.urlApi + "/contatoform"
            );
            this.content = data[0].content;
            this.carregando = false;
            this.$vs.loading.close();
            },

        }        
    }
</script>

<style lang="scss" scoped>

</style>